import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
var CategoryService = /** @class */ (function () {
    function CategoryService(http, auth) {
        this.http = http;
        this.auth = auth;
        this.URL = environment.baseServerURL + "/administration";
    }
    CategoryService.prototype.buildURL = function (subPath) {
        return this.URL + "/" + this.auth.user.company.id + "/category/" + subPath;
    };
    CategoryService.prototype.getCategoriesList = function () {
        return this.http.get(this.buildURL(''), {
            withCredentials: true
        });
    };
    CategoryService.prototype.getFavoriteCategoriesList = function () {
        return this.http.get(this.buildURL('favorite'), {
            withCredentials: true
        });
    };
    CategoryService.prototype.createCategory = function (category) {
        return this.http.post(this.buildURL(''), category, {
            withCredentials: true
        });
    };
    CategoryService.prototype.updateCategory = function (category) {
        return this.http.put(this.buildURL(category.id), category, {
            withCredentials: true
        });
    };
    CategoryService.prototype.deleteCategory = function (id) {
        return this.http.delete(this.buildURL(id), {
            withCredentials: true
        });
    };
    CategoryService.prototype.loadCategory = function (id) {
        return this.http.post(this.buildURL("load/" + id), {}, {
            withCredentials: true
        });
    };
    CategoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CategoryService_Factory() { return new CategoryService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: CategoryService, providedIn: "root" });
    return CategoryService;
}());
export { CategoryService };
